'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.encodeActionType = encodeActionType;
exports.decodeActionType = decodeActionType;
exports.actionToType = actionToType;
exports.typeToAction = typeToAction;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # 生成actionType
 *
 * ```
 *  encodeActionType('user', 'getUser', 'success') => '@@user/getUser/success';
 *
 *  encodeActionType('user', 'getUser') => '@@user/getUser'
 * ```
 */
function encodeActionType(ns, name, status) {
  if (status) {
    return '@@' + ns + '/' + name + '/' + status;
  } else {
    return '@@' + ns + '/' + name;
  }
}

function decodeActionType(type) {
  var _type$split = type.split('/'),
      _type$split2 = (0, _slicedToArray3.default)(_type$split, 3),
      modelName = _type$split2[0],
      actionName = _type$split2[1],
      status = _type$split2[2];

  return [modelName.substr(2), actionName, status];
}

function actionToType(actionName) {
  return '@@' + actionName.replace(/\./g, '/');
}

function typeToAction(ns, name, status) {
  if (status) {
    return ns + '.' + name + '.' + status;
  } else {
    return ns + '.' + name;
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/seed/actionType.js
// module id = 85
// module chunks = 0